<div id="lock" class="flex flex-col" fusePerfectScrollbar>
  <div id="lock-form-wrapper" class="flex items-center justify-center">
    <div id="lock-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="lock-form-header flex flex-col items-center sm:flex-row sm:items-start">
        <div class="avatar-container">
          <img class="avatar big" src="assets/images/avatars/profile.svg" />
          <mat-icon class="s-36">lock</mat-icon>
        </div>

        <div>
          <div i18n class="title">АККАУНТ ЗАБЛОКИРОВАН</div>
          <div i18n class="subtitle">Ваша учетная запись не активирована или была заблокирована администратором.</div>
        </div>
      </div>

      <div class="message mt-6" *ngIf="userId">
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }"
          >Перейти на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
